module.exports = __webpack_public_path__ + "header_two.f2f2de96e14a40255e93.jpg";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/img/landing/header_two.jpg
// module id = ../../../../../ng-src/assets/img/landing/header_two.jpg
// module chunks = styles